import {booleanAttribute, Component, OnInit} from '@angular/core';
import {DocumentViewerPageComponent} from '../../shared/components/document-viewer-page/document-viewer-page.component';
import {ActivatedRoute} from '@angular/router';
import {PaymentsService} from '../../core/api/payments.service';
import {MetricsService} from '../../core/services/metrics.service';
import {HttpCacheService} from '../../core/services/http-cache.service';

@Component({
  selector: 'deposit',
  templateUrl: './deposit.component.html',
  imports: [
    DocumentViewerPageComponent
  ]
})
export class DepositComponent implements OnInit {
  checkinId: number = 0;
  checkoutUrl: string = '';


  constructor(
    private route: ActivatedRoute,
    private paymentService: PaymentsService,
    private metricsService: MetricsService,
    private cache: HttpCacheService,
  ) {
  }

  ngOnInit(): void {
    this.checkinId = Number(this.route.snapshot.paramMap.get('checkinId'));
    this.loadPaymentForm();
    this.cache.invalidate();
  }

  loadPaymentForm(): void {
    this.paymentService.getPaymentForm(this.checkinId).subscribe({
      next: (response: string) => {
        this.metricsService.deposit();

        this.checkoutUrl = response;
      },
      error: (error) => {
        console.error('Error al obtener el formulario de pago:', error);
      }
    });
  }

}
